import { render } from "./NavigationBar.vue?vue&type=template&id=01348cc7"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
script.render = render

export default script